// @flow
import React from "react";
import ForgottenPasswordView from "buba-components/src/views/ForgottenPassword";

const ForgottenPassword = () => <ForgottenPasswordView />;

export default ForgottenPassword;
